// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2pU28","infected":"Cards_infected__2tMtw","recovered":"Cards_recovered__1Tnov","deaths":"Cards_deaths__1nwq5","loading":"Cards_loading__28uq-"};